import PropTypes from 'prop-types';
import * as Yup from 'yup';
// form
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
// @mui
import { Stack, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// hooks
import useIsMountedRef from '../../../hooks/useIsMountedRef';
// components
import { FormProvider, RHFTextField } from '../../../components/hook-form';

import axios from 'axios';
// config
import { EVENT_ID, INPUT_ID } from '../../../config';

// ----------------------------------------------------------------------

ResetPasswordForm.propTypes = {
  onSent: PropTypes.func,
  onGetEmail: PropTypes.func,
};

export default function ResetPasswordForm({ onSent }) {
  const isMountedRef = useIsMountedRef();

  const ResetPasswordSchema = Yup.object().shape({
    email: Yup.string().email('이메일을 정확히 입력해주세요').required('이메일을 입력해주세요'),
  });

  const methods = useForm({
    resolver: yupResolver(ResetPasswordSchema),
    defaultValues: { email: '' },
  });

  const {
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    try {
      const response = await axios.post(`${process.env.HOST_API_KEY}/api/accounts/cert/email/generate/`, {
        cert_type: "reset_employee",
        email: data.email
      });
      const { status } = response;
      if (isMountedRef.current && status === 201) {
        onSent(true, data.email);
      } else {
        setError('afterSubmit', { message: '이메일 주소를 확인해주세요' });
      }
    } catch (error) {
      setError('afterSubmit', { message: '이메일 주소를 확인해주세요' });
      console.error(error);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}
        <RHFTextField name="email" label="이메일" id={INPUT_ID.resetpasswordEmail} />

        <LoadingButton id={EVENT_ID.bizSendResetPasswordEmail} fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          비밀번호 재설정 메일 보내기
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
